export const language_en={
    'nav.home': 'Home',
    'nav.cexs': 'CEXs & Core Team',
    'nav.operations': 'Operations',
    'nav.transactions': 'Transactions',
    'nav.blocks': 'Blocks',
    'nav.nodes': 'Nodes',
    'nav.nodes_mainnet': 'Mainnet Nodes',
    'nav.nodes_testnet': 'Testnet Nodes',
    'nav.stats': 'Statistics',
    'nav.defi': 'DeFi',
    'nav.assets': 'Assets',
    'nav.pools': 'Pools',
    'nav.trades': 'Trades',
    'stats.accounts': 'Account Distribution',
    'stats.unlocks': 'Pi Unlocks 30 Days',
    'stats.unlocks_monthly': 'Pi Unlocks Monthly',
    'stats.domain_auction': 'Domain Auction Stats',
    'stats.largest_tx': 'Largest Transactions',
    'stats.migrate': 'Migration Statistics',
    'search.placeholder': 'Search...',
    // Add more translations as needed
    'operations.self_transfer': 'Self Transfer',
    'operations.domain_auction': 'Domain Auction',
    'operations.claim_claimable_balance': 'Claim π',
    'operations.create_account': 'Create Account',
    'operations.payment': 'Payment',
    'operations.path_payment_strict_receive': 'Path Payment Strict Receive',
    'operations.path_payment_strict_send': 'Path Payment Strict Send',
    'operations.manage_sell_offer': 'Manage Sell Offer',
    'operations.create_passive_sell_offer': 'Create Passive Sell Offer',
    'operations.set_options': 'Set Options',
    'operations.change_trust': 'Change Trust',
    'operations.allow_trust': 'Allow Trust',
    'operations.account_merge': 'Account Merge',
    'operations.inflation': 'Inflation',
    'operations.manage_data': 'Manage Data',
    'operations.bump_sequence': 'Bump Sequence',
    'operations.manage_buy_offer': 'Manage Buy Offer',
    'operations.create_passive_buy_offer': 'Create Passive Buy Offer',
    'operations.create_claimable_balance': 'Create Claimable Balance',
    'operations.claim_claimable_balance_atom': 'Claim Claimable Balance',
    'operations.deposit': 'Deposit',
    'operations.withdraw': 'Withdraw',
    'operations.pay': 'Pay',
    'operations.to': 'to',
    'operations.from': 'from',
    'operations.claimant': 'Claimant',
    'operations.with_starting_balance': 'with starting balance',
    'operations.claim': 'Claim',
    // Operations page translations
    'operations.heading': 'Explore the latest operations on Pi Network blockchain',
    'operations.title': 'Latest Operations on Pi Network',
    'operations.description': 'Explore the latest operations on the Pi Network blockchain.',
    'operations.source_account': 'Source account',
    'operations.operation': 'Operation',
    'operations.amount': 'Amount',
    'operations.tx': 'Tx',
    'operations.time': 'Time',
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'pagination.page': 'Page',
    'account.title': 'Account {{address}} - Pi Network Explorer',
    'account.heading': 'Account Detail',
    'account.heading_with_address': 'Account {{address}}',
    'account.description': 'Details of Account {{address}} on the Pi Network.',
    'account.loading': 'Loading Account Details...',
    'account.not_found': 'Account not found.',
    'account.scam_warning_title': 'Scam Warning',
    'account.scam_warning_description': 'This wallet address has been flagged as unsafe based on community reports. It may be associated with scams, compromised private keys, or unauthorized access. Proceed with caution before making any transactions.',
    'account.overview': 'Overview',
    'account.available_balance': 'Available balance',
    'account.last_modified_time': 'Last modified time',
    'account.locking': 'Locking',
    'account.total_locking': 'Total locking ({{count}} items)',
    'account.next_unlock_time': 'Next unlock time',
    'account.claimable': 'Claimable',
    'account.amount': 'Amount',
    'account.number_of_items': 'Number of items',
    'account.over_100_items': 'over 100 items',
    'account.tx_hash': 'Tx Hash',
    'account.operation_count': 'Operation Count',
    'account.fee': 'Fee',
    'account.created_at': 'Created At',
    'account.account': 'Account',
    'account.effect': 'Effect',
    'account.sponsor': 'Sponsor',
    'account.predicate': 'Predicate',
    'account.create_time': 'Create time',
    'account.latest_100_claimable': 'Latest 100 claimable balances',
    'account.tabs.operations': 'Operations',
    'account.tabs.transactions': 'Transactions',
    'account.tabs.effects': 'Effects',
    'account.tabs.claimable_balances': 'Claimable balances',
    // Effect types (common ones)
    'effects.account_credited': 'Account credited',
    'effects.account_debited': 'Account debited',
    'effects.account_created': 'Account created',
    'effects.claimable_balance_created': 'Claimable balance created',
    'effects.claimable_balance_claimed': 'Claimable balance claimed',
    'effects.claimable_balance_claimant_created': 'Claimable balance claimant created',
    'effects.account_removed': 'Account removed',
    'effects.account_thresholds_updated': 'Account thresholds updated',
    'effects.account_home_domain_updated': 'Account home domain updated',
    'effects.account_flags_updated': 'Account flags updated',
    'effects.account_inflation_destination_updated': 'Account inflation destination updated',
    'effects.signer_created': 'Signer created',
    'effects.signer_removed': 'Signer removed',
    'effects.signer_updated': 'Signer updated',
    'effects.trustline_removed': 'Trustline removed',
    'effects.trustline_updated': 'Trustline updated',
    'effects.trustline_authorized': 'Trustline authorized',
    'effects.trustline_deauthorized': 'Trustline deauthorized',
    'effects.offer_created': 'Offer created',
    'effects.offer_removed': 'Offer removed',
    'effects.offer_updated': 'Offer updated',
    'effects.trade': 'Trade executed',
    'effects.data_created': 'Data created',
    'effects.data_removed': 'Data removed',
    'effects.data_updated': 'Data updated',
    'effects.sequence_bumped': 'Sequence bumped',
    'effects.liquidity_pool_created': 'Liquidity pool created',
    'effects.liquidity_pool_removed': 'Liquidity pool removed',
    'effects.liquidity_pool_deposited': 'Liquidity pool deposited',
    'effects.liquidity_pool_withdrew': 'Liquidity pool withdrew',
    'effects.liquidity_pool_trade': 'Liquidity pool trade',
    'effects.liquidity_pool_revoked': 'Liquidity pool revoked',
    'effects.contract_credited': 'Contract credited',
    'effects.contract_debited': 'Contract debited',
    'effects.claimable_balance_sponsorship_removed': 'Claimable balance sponsorship removed',
    'account_stats.heading': 'Pi Account Statistics - Balance Distribution & Top Accounts',
    'account_stats.title': 'Pi Account Statistics - Balance Distribution & Top Accounts',
    'account_stats.description': 'View the richest Pi accounts and overall balance distribution across the Pi network.',
    'account_stats.intro_text': 'Explore the distribution of Pi across all accounts and view the top Pi holders.',
    'account_stats.distribution_chart_title': 'Pi Holder Distribution',
    'account_stats.categories_title': 'Distribution Categories',
    'account_stats.top_accounts_title': 'Top Pi Accounts',
    'account_stats.accounts': 'accounts',
    'account_stats.of_total': 'of total',
    'account_stats.table.category': 'Category',
    'account_stats.table.balance_range': 'Balance Range',
    'account_stats.table.usd_value': 'USD Value',
    'account_stats.table.accounts': 'Accounts',
    'account_stats.table.percentage': '% of Total',
    'account_stats.table.total': 'Total',
    'account_stats.table.rank': 'Rank',
    'account_stats.table.account': 'Account',
    'account_stats.table.balance': 'Balance',
    'account_stats.table.value': 'Value',
    'account_stats.table.supply_percentage': '% of Supply',
    'account_stats.categories.whales': 'Whales',
    'account_stats.categories.sharks': 'Sharks',
    'account_stats.categories.dolphins': 'Dolphins',
    'account_stats.categories.tunas': 'Tunas',
    'account_stats.categories.fish': 'Fish',
    'account_stats.categories.shrimps': 'Shrimps',
    'account_stats.categories.plankton': 'Plankton',
    'account_stats.categories.microbes': 'Microbes',
    'number.billion_short': 'B',
    'number.million_short': 'M',
    'number.thousand_short': 'K',
    'common.loading': 'Loading...',
    'common.sponsored': 'Sponsored',
    'common.ad': 'Ad',
    'common.ad_not_available': 'Sponsored content not available in your region',

    'blocks.heading': 'Explore the latest blocks on Pi Network blockchain',
    'blocks.title': 'Latest Blocks on Pi Network',
    'blocks.description': 'Explore the latest blocks on the Pi Network blockchain.',
    'blocks.sequence': 'Sequence',
    'blocks.hash': 'Hash',
    'blocks.transactions': 'Transactions',
    'blocks.operations': 'Operations',
    'blocks.time': 'Time',
    'blocks.successful': 'successful',
    'blocks.failed': 'failed',
    'block.title': 'Block #{{sequence}} - Pi Network Explorer',
    'block.heading': 'Block #{{sequence}}',
    'block.description': 'Details of Block #{{sequence}} on the Pi Network blockchain.',
    'block.loading': 'Loading Block Details...',
    'block.not_found': 'Block not found.',
    'block.information': 'Block Information',
    'block.hash': 'Hash',
    'block.previous_hash': 'Previous Hash',
    'block.sequence': 'Sequence',
    'block.time': 'Time',
    'block.total_coins': 'Total Coins',
    'block.fee_pool': 'Fee Pool',
    'block.base_fee': 'Base Fee',
    'block.base_reserve': 'Base Reserve',
    'block.protocol_version': 'Protocol Version',
    'block.tx_hash': 'Tx Hash',
    'block.operation_count': 'Operation Count',
    'block.fee': 'Fee',
    'block.created_at': 'Created At',
    'block.tabs.transactions': 'Transactions',
    'block.tabs.operations': 'Operations', 
    'block.tabs.effects': 'Effects',
    'cex.heading': 'CEX & Core team accounts Statistics',
    'cex.title': 'CEX & Core team accounts on Pi Network',
    'cex.description': 'Explore the CEX & Core team accounts on the Pi Network blockchain.',
    'cex.wallet_balances': 'CEXs wallet balances',
    'cex.core_team_wallets': 'Pi core team wallets',
    'cex.cmc_ranking': 'CMC Ranking',
    'cex.exchange': 'Exchange',
    'cex.chart_link': 'Chart link',
    'cex.signup_link': 'SignUp link',
    'cex.wallet_address': 'Wallet Address',
    'cex.balance_pi': 'Balance (Pi)',
    'cex.balance_usd': 'Balance (USD)',
    'cex.chart': 'Chart',
    'cex.signup': 'SignUp',
    'cex.total': 'Total',
    'cex.note': 'Note',
    'cex.pi_foundation': 'Pi Foundation',
    'cex.total_in': 'Total In (last 24h)',
    'cex.total_out': 'Total Out (last 24h)',
    'cex.net_difference': 'Net Flow (last 24h)',
    'cex.flow_data_updated': 'Flow data last updated (refreshed every 30 mins)',
    'cex.actions': 'Actions',
    'cex.filter_transactions_tooltip': 'Filter transactions for this address',
    'cex.filter_txs_button': "Filter Txs",
    'contact.heading': 'Contact Us',
    'contact.title': 'Contact PiScan',
    'contact.description': 'Contact PiScan for any queries or feedback.',
    'contact.intro_text': 'If you have any questions, feel free to reach us at',
    'contact.success_message': 'Thank you for contacting us! We will get back to you soon.',
    'contact.form.name': 'Your Name',
    'contact.form.email': 'Your Email',
    'contact.form.message': 'Message',
    'contact.form.submit': 'Send Message',
    'home.heading': 'Explore Pi Network transactions, wallets, and statistics',
    'home.title': 'Explore Pi Network transactions, wallets, and statistics',
    'home.description': 'Explore Pi Network transactions, wallets, and statistics',
    'home.market_cap': 'Market cap',
    'home.price': 'Price',
    'home.24h_change': '24h%',
    'home.pi_supply': 'Pi Supply',
    'home.circulating': 'Circulating',
    'home.locked': 'Locked',
    'home.cex_balance_total': 'CEX Balance (total)',
    'home.view_all': 'View All',
    'home.network_stats': 'Network Stats',
    'home.blocks': 'Blocks',
    'home.tps': 'TPS',
    'home.latest_transactions': 'Latest Transactions',
    'home.signature': 'Signature',
    'home.time': 'Time',
    'home.block': 'Block',
    'home.ops': 'Ops',
    'home.latest_operations': 'Latest Operations',
    'home.source_account': 'Source account',
    'home.operation': 'Operation',
    'home.amount': 'Amount',
    'home.tx': 'Tx',
    'nodes.heading': 'Pi Network Node Map & Network Statistics',
    'nodes.title': 'Pi Network Nodes & Validators',
    'nodes.description': 'Explore Pi Network nodes, validators, and network topology. View the global distribution and connectivity of nodes.',
    'nodes.active_nodes': 'Active Nodes',
    'nodes.validators': 'Validators',
    'nodes.known_peers': 'Known Peers',
    'nodes.disconnected_nodes': 'Disconnected Nodes',
    'nodes.network_graph': 'Network Graph',
    'nodes.node_types': 'Node Types',
    'nodes.validator': 'Validator',
    'nodes.phantom_validators': 'Unreachable validators',
    'nodes.watcher': 'Watcher',
    'nodes.disconnected_private': 'Disconnected/Private',
    'nodes.click_to_highlight': 'Click on a node to highlight its connections',
    'nodes.global_distribution': 'Global Distribution',
    'nodes.mapped_nodes': 'mapped nodes',
    'nodes.node_details': 'Node Details',
    'nodes.nodes': 'nodes',
    'nodes.address': 'Address',
    'nodes.type': 'Type',
    'nodes.location': 'Location',
    'nodes.isp': 'ISP',
    'nodes.version': 'Version',
    'nodes.trust': 'Trust',
    'nodes.trusted_by': 'Trusted by',
    'nodes.status': 'Status',
    'nodes.status.connected': 'Connected',
    'nodes.status.disconnected': 'Disconnected',
    'nodes.status.private': 'Private',
    'nodes.active_quorum_sets': 'Active Quorum Sets',
    'nodes.active': 'active',
    'nodes.quorum_hash': 'Quorum Hash',
    'nodes.node_id': 'Node ID',
    'nodes.unknown': 'Unknown',
    'nodes.core_team': 'Core Team',
    'nodes.tooltip.node_id': 'Node ID',
    'nodes.tooltip.address': 'Address',
    'nodes.tooltip.type': 'Type',
    'nodes.tooltip.status': 'Status',
    'nodes.tooltip.version': 'Version',
    'nodes.tooltip.location': 'Location',
    'nodes.tooltip.not_accessible': 'Not accessible',
    'nodes.country_statistics': 'Country Statistics',
    'nodes.country': 'Country',
    'nodes.connected_nodes': 'Connected Nodes',
    'nodes.no_country_data': 'No country data available',
    'nodes.city_statistics': 'City Statistics',
    'nodes.city': 'City',
    'nodes.no_city_data': 'No city data available',
    'nodes.online_nodes_only': 'Online Nodes Only',
            
    // Nodes Testnet translations
    'nodes_testnet.heading': 'Pi Testnet Node Statistics & Network Analysis',
    'nodes_testnet.title': 'Pi Testnet Nodes & Network Statistics',
    'nodes_testnet.description': 'Explore Pi Testnet node statistics, geographic distribution, and network activity metrics.',
    'nodes_testnet.total_nodes': 'Total Nodes',
    'nodes_testnet.active_nodes': 'Active Nodes',
    'nodes_testnet.inactive_nodes': 'Inactive Nodes',
    'nodes_testnet.last_updated': 'Last Updated',
    'nodes_testnet.country_statistics': 'Country Statistics',
    'nodes_testnet.city_statistics': 'City Statistics',
    'nodes_testnet.country': 'Country',
    'nodes_testnet.city': 'City',
    'nodes_testnet.active_rate': 'Active Rate',
    'nodes_testnet.summary_title': 'Network Summary',
    'nodes_testnet.summary_description': 'Overview of Pi Testnet node distribution and activity across the global network.',
    'nodes_testnet.total_peers': 'Total Peers',
    'nodes_testnet.active_peers': 'Active Peers',
    'nodes_testnet.activity_rate': 'Activity Rate',
            
    // English translations
    'report_scam.heading': 'Report Scam Wallet',
    'report_scam.title': 'Report Scam Wallet on PiScan',
    'report_scam.description': 'Report a scam wallet address involved in fraudulent or scam activities.',
    'report_scam.intro_text': 'If you have encountered a suspicious wallet address involved in fraudulent or scam activities, please report it using the form below. Our team will review the submission, and if confirmed as a scam, we will mark the wallet as "Scam" on PiScan to warn the community.',
    'report_scam.success_message': 'Thank you for your report! Our team will review it as soon as possible.',
    'report_scam.form.wallet_address': 'Wallet Address',
    'report_scam.form.wallet_placeholder': 'Enter the scam wallet address',
    'report_scam.form.reason': 'Reason for Reporting',
    'report_scam.form.reason_placeholder': 'Describe why this wallet is suspected of scam activities',
    'report_scam.form.email': 'Your Email (Optional)',
    'report_scam.form.email_placeholder': 'Enter your email (optional)',
    'report_scam.form.email_note': 'We may contact you for further details.',
    'report_scam.form.submit': 'Submit Report',

    'transaction.title': 'Transaction #{{id}} on Pi Network',
    'transaction.heading': 'Transaction details',
    'transaction.description': 'Details of transaction #{{id}} on the Pi Network blockchain.',
    'transaction.loading': 'Loading Transaction Details...',
    'transaction.not_found': 'Transaction not found.',
    'transaction.hash': 'Hash',
    'transaction.ledger_block': 'Ledger (Block)',
    'transaction.result': 'Result',
    'transaction.source_account': 'Source account',
    'transaction.fee_account': 'Fee account',
    'transaction.fee': 'Fee',
    'transaction.operation_count': 'Number of Operations',
    'transaction.summary': 'Summary',
    'transaction.operations': 'Operations',
    'transaction.effects': 'Effects',
    'transaction.account': 'Account',
    'transaction.operation': 'Operation',
    'transaction.effect': 'Effect',
    'transaction.amount': 'Amount',
    'transaction.successful': 'Successful',
    'transaction.failed': 'Failed',
    'transaction.loading_details': 'Loading transaction details...',
    'transaction.with_operations': 'Transaction with {{count}} operations',
    'transaction.core_team_distributed': 'Pi Core Team distributed',
    'transaction.to': 'to',
    'transaction.accounts': 'accounts',
    'transaction.locked_for_days': ', locked for {{days}} days',
    'transaction.locked_range_days': ', with lock-up periods ranging from {{minDays}} to {{maxDays}} days',
    'transaction.created_at': 'Created At',

    'unlock_stats.heading': 'Pi Unlock Statistics - Next 30 Days',
    'unlock_stats.title': 'Pi Unlock Statistics - Next 30 Days',
    'unlock_stats.description': 'View the projected Pi cryptocurrency unlock statistics for the next 30 days.',
    'unlock_stats.intro_text': 'Pi unlocks over the next 30 days based on claimable balances—either user-locked or distributed by the Pi Core Team. Unreleased Pi not yet in claimable balances cannot be tracked. Check regularly for updates. All times are in UTC.',
    'unlock_stats.today_note': 'Today\'s unlock amount represents the remaining Pi to be unlocked from now until the end of the day (UTC).',
    'unlock_stats.updated_at': 'Data updated at:',
    'unlock_stats.unknown': 'Unknown',
    'unlock_stats.total_locked': 'Total Locked Pi',
    'unlock_stats.total_next_30': 'Total Unlock in Next 30d',
    'unlock_stats.of_total_locked': 'of total locked',
    'unlock_stats.avg_daily': 'Avg Daily Unlock',
    'unlock_stats.per_day': 'per day',
    'unlock_stats.highest_day': 'Highest Day',
    'unlock_stats.on': 'on',
    'unlock_stats.chart_title': 'Pi Unlock Chart - Next 30 Days',
    'unlock_stats.data_table': 'Unlock Data Table',
    'unlock_stats.date': 'Date',
    'unlock_stats.amount': 'Amount',
    'unlock_stats.value': 'Value',
    'unlock_stats.pi_unlock': 'Pi Unlock',
    'unlock_stats.y_axis_label': 'Pi unlock (in millions)',
    "unlock_stats.monthly_heading": "Monthly Pi Unlock Statistics",
    "unlock_stats.monthly_title": "Monthly Pi Unlock Statistics",
    // Add to LanguageContext.tsx
    "unlock_stats.total_next_12": "Total next 12 months",
    "unlock_stats.monthly_description": "View Pi cryptocurrency unlock statistics by month",
    "unlock_stats.monthly_intro_text": "View Pi cryptocurrency unlock statistics by month.",
    "unlock_stats.monthly_note": "Statistics are based on eligible unlock claims.",
    "unlock_stats.monthly_chart_title": "Pi Unlock Statistics by Month",
    "unlock_stats.total_forecast": "Total Statistics",
    "unlock_stats.monthly_data_table": "Monthly Unlock Data",
    "unlock_stats.total_locking": "Total locking",
    "unlock_stats.avg_monthly": "Avg Monthly",
    "unlock_stats.highest_month": "Highest Month",
    "unlock_stats.per_month": "per month",
    "unlock_stats.in": "in",
    "unlock_stats.month": "Month",
    "unlock_stats.view_daily": "View Daily Unlock Statistics",
    "unlock_stats.view_monthly": "View Monthly Unlock Statistics",

    'common.loading_error': 'Error loading data. Please try again later.',

    'settings.aria_label': 'Open settings',
    'settings.language': 'Language',
    'settings.appearance': 'Appearance',
    'settings.dark_mode': 'Dark mode',
    'settings.light': 'Light',
    'settings.dark': 'Dark',

    "transactios.heading": "Explore the latest transactions on Pi Network blockchain",
    "transactions.title": "Latest Transactions on Pi Network",
    "transactions.description": "Explore the latest transactions on the Pi Network blockchain.",

    
      "domain_auction_stats.heading": "Pi Domain Auction Statistics",
      "domain_auction_stats.title": "Pi Domain Auction Stats | Pi Network Statistics",
      "domain_auction_stats.description": "Analysis of Pi Network domain auctions, showing the distribution of bids across different price ranges and total Pi bid so far.",
      "domain_auction_stats.intro_text": "This page provides an analysis of Pi domain auctions, highlighting bid distributions across different price ranges.",
      "domain_auction_stats.last_updated": "Last updated",
      "domain_auction_stats.summary_title": "Auction Bidding Summary",
      "domain_auction_stats.total_bids": "Total bids placed",
      "domain_auction_stats.total_pi_bid": "Total Pi bid so far",
      "domain_auction_stats.estimated_value": "Estimated value (USD)",
      "domain_auction_stats.pi_price": "Current Pi price",
      "domain_auction_stats.distribution_title": "Bid Distribution",
      "domain_auction_stats.chart_title": "Bid Price Distribution",
      "domain_auction_stats.details_title": "Live Bid Breakdown",
      "domain_auction_stats.bids": "bids",
      "domain_auction_stats.of_total": "of total bids placed",
      "domain_auction_stats.bid_count": "Number of Bids",
      "domain_auction_stats.ranges.low": "Low Bids",
      "domain_auction_stats.ranges.medium": "Standard Bids",
      "domain_auction_stats.ranges.high": "Premium Bids",
      "domain_auction_stats.ranges.premium": "Luxury Bids",
      "domain_auction_stats.ranges.elite": "Elite Bids",
      "domain_auction_stats.table.price_range": "Bid Price Range",
      "domain_auction_stats.table.bid_count": "Number of Bids",
      "domain_auction_stats.table.percentage": "Percentage",
      "domain_auction_stats.table.total": "Total Bids",
      "domain_auction_stats.highest_bid": "Highest Bid",
      "domain_auction_stats.top_bids_title": "Top Bids",
      "domain_auction_stats.table.account": "Account",
      "domain_auction_stats.table.bid_amount": "Bid Amount",
      "domain_auction_stats.table.usd_value": "USD Value",
      
      "largest_tx.heading": "Largest Pi Transactions (Last 24h)",
      "largest_tx.title": "Largest Pi Transactions in the Last 24 Hours - PiScan",
      "largest_tx.description": "Explore the largest Pi transactions on the Pi Network blockchain in the past 24 hours.",
      "largest_tx.list_heading": "Top Transactions by Amount (Last 24h)",
      "largest_tx.rank": "Rank",
      "largest_tx.transaction": "Transaction",
      "largest_tx.account": "Account",
      "largest_tx.amount": "Amount (π)",
      "largest_tx.date": "Date & Time",
      "largest_tx.no_data": "No transaction data available in the last 24 hours.",
      "largest_tx.fetch_error": "Failed to fetch transaction data.",
      "largest_tx.loading": "Loading largest transactions...",
      "largest_tx.largest_amount": "Largest Transaction Amount (Last 24h)",
      "largest_tx.latest_large_tx": "Latest Large Transaction (Last 24h)",
      "largest_tx.total_value": "Total Value (Top 100 Transactions in Last 24h)",
    
      "migrate_stats.heading": "Pi Migration Statistics",
      "migrate_stats.title": "Pi Migration to Mainnet Statistics - PiScan",
      "migrate_stats.description": "Track daily Pi migration to mainnet statistics for recent days.",
      "migrate_stats.last_updated": "Last Updated",
    
      "migrate_stats.daily_migration": "Daily Migration Volume",
      "migrate_stats.daily_stats": "Migration Statistics by Day",
      "migrate_stats.loading": "Loading migration statistics...",
      "migrate_stats.no_data": "No migration data available.",
      "migrate_stats.fetch_error": "Failed to fetch migration data.",
      "migrate_stats.date": "Date",
      "migrate_stats.amount": "Amount (π)",
      "migrate_stats.percentage": "Percentage",
      "migrate_stats.total": "Total",
      "migrate_stats.pi_migrated": "Total Pi Migrated",
      "migrate_stats.date_label": "Date: {{date}}",
      "migrate_stats.usd_value": "USD Value",
      "migrate_stats.at_price": "at the current price of",
      "migrate_stats.current_price_note": "USD values calculated at the current Pi price of {{price}} per π.",
     
    "transactions_filter.heading": "Filter Transactions",
    "transactions_filter.title": "Filter Transactions | Pi Scan",
    "transactions_filter.description": "Filter and search for Pi Network transactions based on address, amount, and other criteria.",
    "transactions_filter.address_required_error": "Address is required.",
    "transactions_filter.min_amount_required_error": "Minimum amount is required.",
    "transactions_filter.amount_too_low_error": "Amount cannot be less than 10,000",
    "transactions_filter.min_exceeds_max_error": "Minimum amount cannot exceed maximum amount",
    "transactions_filter.filter_options": "Filter Options",
    "transactions_filter.address": "Address",
    "transactions_filter.address_placeholder": "Enter account address",
    "transactions_filter.min_amount": "Min Amount (Pi)",
    "transactions_filter.min_amount_placeholder": "e.g., 10000",
    "transactions_filter.max_amount": "Max Amount (Pi)",
    "transactions_filter.max_amount_placeholder": "e.g., 100000",
    "transactions_filter.apply_filters": "Apply",
    "transactions_filter.clear": "Clear",
    "transactions_filter.no_results": "No transactions found matching your criteria.",
    "transactions_filter.results": "Results",
    "transactions_filter.table.hash": "Tx Hash",
    "transactions_filter.table.time": "Time",
    "transactions_filter.table.from": "From",
    "transactions_filter.table.to": "To",
    "transactions_filter.table.amount": "Amount (Pi)",
    "transactions_filter.apply_filters_prompt": "Please apply filters to see results." ,       
    "transactions_filter.table.tx": "Tx",
    "transactions_filter.table.detail_button": "View Details",
    "transactions_filter.operation_text.payment": "Payment of {{amount}} Pi from {{from}} to {{to}}",
    "transactions_filter.operation_text.unknown": "Unknown Operation",

    // Assets page translations
    'assets.heading': 'Pi Network Assets (Tokens)',
    'assets.title': 'Pi Network Assets (Tokens)',
    'assets.description': 'Explore all assets (tokens) on the Pi Network blockchain',
    'assets.total_assets': 'Total Assets (Tokens)',
    'assets.showing_results': 'Showing {{count}} of {{total}} assets',
    'assets.search_placeholder': 'Search by asset code or issuer...',
    'assets.assets_list': 'Assets List',
    'assets.previous': 'Previous',
    'assets.next': 'Next',
    'assets.asset_code': 'Asset Code',
    'assets.type': 'Type',
    'assets.issuer': 'Issuer',
    'assets.accounts': 'Accounts',
    'assets.holders': 'Holders',
    'assets.total_supply': 'Total Supply',
    'assets.in_pools': 'In Pools',
    'assets.circulating': 'Circulating',
    'assets.pools': 'Pools',
        'assets.actions': 'Actions',
    'assets.view_toml': 'View TOML',
    'assets.testnet_warning': 'These are testnet tokens and have no real value',

    // Trades page translations
    'trades.heading': 'Pi Network Trades',
    'trades.title': 'Pi Network Trades',
    'trades.description': 'Explore trading activity on the Pi Network blockchain',
    'trades.total_trades': 'Trading Activity',
    'trades.showing_results': 'Showing {{count}} of {{total}} trades',
    'trades.search_placeholder': 'Search by asset or account...',
    'trades.trades_list': 'Recent Trades',
    'trades.exchange_rates': 'Exchange Rates Summary',
    'trades.latest_rates': 'Latest rates from recent trades',
    'trades.previous': 'Previous',
    'trades.next': 'Next',
    'trades.time': 'Time',
    'trades.type': 'Type',
    'trades.summary': 'Trade Summary',
    'trades.trading_pair': 'Trading Pair',
    'trades.amount': 'Amount',
    'trades.price': 'Price',
    'trades.accounts': 'Accounts',
    'trades.links': 'Links',
    'trades.sell_order': 'Sell',
    'trades.buy_order': 'Buy',
    'trades.base': 'Base',
    'trades.counter': 'Counter',
    'trades.operation': 'Operation',
    'trades.view_operation': 'View Operation Details',
    'trades.testnet_warning': 'These are testnet trades and have no real value',

    // Asset Detail page translations
    'assetDetail.heading': 'Asset Details',
    'assetDetail.back_to_assets': 'Back to Assets',
    'assetDetail.asset_info': 'Asset Information',
    'assetDetail.total_supply': 'Total Supply',
    'assetDetail.holders': 'Holders',
    'assetDetail.liquidity_pools': 'Liquidity Pools',
    'assetDetail.claimable_balances': 'Claimable Balances',
    'assetDetail.in_pools': 'In Pools',
    'assetDetail.circulating': 'Circulating',
    'assetDetail.trades': 'Trades',
    'assetDetail.search_trades': 'Search trades...',
    'assetDetail.previous': 'Previous',
    'assetDetail.next': 'Next',
    'assetDetail.time': 'Time',
    'assetDetail.type': 'Type',
    'assetDetail.summary': 'Summary',
    'assetDetail.price': 'Price',
    'assetDetail.accounts': 'Accounts',
    'assetDetail.links': 'Links',
    'assetDetail.base': 'Base',
    'assetDetail.counter': 'Counter',
    'assetDetail.sell': 'Sell',
    'assetDetail.buy': 'Buy',
    'assetDetail.operation': 'Operation',
    'assetDetail.view_operation': 'View Operation',
    'assetDetail.liquidity_pools_list': 'Liquidity Pools',
    'assetDetail.pool_id': 'Pool ID',
    'assetDetail.reserves': 'Reserves',
    'assetDetail.total_shares': 'Total Shares',
    'assetDetail.fee': 'Fee',
    'assetDetail.trustlines': 'Trustlines',
    'assetDetail.last_modified': 'Last Modified',
    'assetDetail.transactions': 'Transactions',
    'assetDetail.operations': 'Operations',
    'assetDetail.view_transactions': 'View Transactions',
    'assetDetail.view_operations': 'View Operations',
    'assetDetail.history': 'History',
    'assetDetail.no_pools_found': 'No liquidity pools found',
    'assetDetail.testnet_warning': 'TESTNET DATA:',
    'assetDetail.testnet_description': 'These are testnet operations and may not reflect mainnet activity.',

    // Pool History
    'poolHistory.heading': 'Pool Operation History',
    'poolHistory.back_to_pool': 'Back to Pool Details',
    'poolHistory.pool_id': 'Pool ID',
    'poolHistory.operation_history': 'Operation History',
    'poolHistory.operation': 'Operation',
    'poolHistory.type': 'Type',
    'poolHistory.details': 'Details',
    'poolHistory.source_account': 'Source Account',
    'poolHistory.time': 'Time',
    'poolHistory.status': 'Status',
    'poolHistory.links': 'Links',
    'poolHistory.success': 'Success',
    'poolHistory.failed': 'Failed',
    'poolHistory.no_operations': 'No operations found',
    'poolHistory.no_operations_desc': 'This pool has no operation history yet.',
    'poolHistory.previous': 'Previous',
    'poolHistory.next': 'Next',
    'poolHistory.view_operation': 'View Operation',
    'poolHistory.view_effects': 'View Effects',
    'poolHistory.effects': 'Effects',
    'poolHistory.testnet_warning': 'TESTNET DATA:',
    'poolHistory.testnet_description': 'These are testnet operations and may not reflect mainnet activity.',

    // Pools page translations
    'pools.heading': 'Pi Network Liquidity Pools',
    'pools.testnet_warning': 'TESTNET DATA:',
    'pools.testnet_description': 'These are testnet operations and may not reflect mainnet activity.',
    'pools.liquidity_pools_list': 'Liquidity Pools',
    'pools.pool_id': 'Pool ID',
    'pools.reserves': 'Reserves',
    'pools.total_shares': 'Total Shares',
    'pools.fee': 'Fee',
    'pools.trustlines': 'Trustlines',
    'pools.last_modified': 'Last Modified',
    'pools.actions': 'Actions',
    'pools.no_pools': 'No liquidity pools found',
    'pools.no_pools_desc': 'There are currently no liquidity pools available.',
    'pools.operations': 'Operations',
    'pools.view_operations': 'View Operations',
    'maintenance.heading': 'PiScan is temporarily unavailable for maintenance',
    'maintenance.title': 'PiScan - Maintenance',
    'maintenance.description': 'PiScan is temporarily paused while the protocol upgrade to version 23 is being completed.',
    'maintenance.status': 'Service update',
    'maintenance.page_title': 'PiScan system upgrade in progress',
    'maintenance.message': 'The protocol upgrade to version 23 is taking longer than initially expected. This upgrade affects the indexing infrastructure and on-chain data analytics services. As a result, PiScan will be temporarily unavailable for several days while the upgrade is completed and verified.',
    'maintenance.protocol_label': 'Protocol version',
    'maintenance.protocol_value': 'Protocol v23',
    'maintenance.affected_label': 'Affected services',
    'maintenance.affected_value': 'Indexing & On-chain Analytics',
    'maintenance.eta_label': 'Expected completion',
    'maintenance.eta_value': 'May 15',
    'maintenance.note': 'The website is expected to resume normal operation after the upgrade process is completed. Thank you for your patience and understanding.'
  }
